import tpv from '@synergycms_core/utils/tpv/base';

const baseUrl = process.env.URL_ENVIRONMENT;

export default class PAYPAL extends tpv {

  /** @type {boolean|number} */
  hotelID = false;
  /** @type {boolean|string} */
  hotelCode = false;
  /** @type {boolean|string} */
  hotelName = false;
  /** @type {boolean|string} */
  trackingId = false;
  /** @type {boolean|string} */
  pinCode = false;
  /** @type {boolean|string} */
  currencyCode = false;
  /** @type {boolean|Map} */
  reservation = false;
  /** @type {number} */
  nRetry = 1;
  /** @type {boolean|function} */
  incrementPaymentRetry = false;
  /** @type {boolean|function} */
  showErrorNotification = false;
  /** @type {boolean|function} */
  sendBookingTmsFunction = false;

  /**
   *
   * @param reservation {Map}
   * @param hotelID {number}
   * @param incrementPaymentRetry {function}
   * @param tpvPaymentStatus {string}
   * @param showErrorNotification {function}
   */
  constructor({reservation, hotelID, incrementPaymentRetry, tpvPaymentStatus, showErrorNotification, sendBookingTmsFunction}) {
    super();
    this.nRetry = parseInt(reservation.getIn(['payment', 'n_retry'], false) || 1, 10);
    this.incrementPaymentRetry = incrementPaymentRetry;
    this.showErrorNotification = showErrorNotification;
    this.trackingId = reservation.get('tracking_id');
    this.pinCode = reservation.get('pin_code');
    this.hotelID = hotelID;
    this.hotelCode = reservation.get('hotel_code');
    this.hotelName = reservation.get('hotel_name');
    this.currencyCode = reservation.getIn(['currency', 'code']);
    this.sendBookingTmsFunction = sendBookingTmsFunction;
    if (
      tpvPaymentStatus === 'PAYPAL:ERROR' &&
      reservation.getIn(['payment', 'payform_code']) === 'paypal'
    ) {
      this.nRetry++;
      this.showErrorNotification('ha ocurrido un error con el proceso de pago online, por favor, vuelva a intentarlo');
      this.incrementPaymentRetry(this.nRetry);
    }

  }

  /**
   *
   * @returns {Promise}
   */
  createTransaction = () => {
    const promise = this.sendBookingTmsFunction ? this.sendBookingTmsFunction() : Promise.resolve();
    return promise.then(() => {
      const url = baseUrl + '/api/hotels/' + this.hotelID + '/cms/create_paypal_transaction/' + this.trackingId;
      const data = {
        tracking_id: this.trackingId,
        hotel_code: this.hotelCode,
        hotel_name: this.hotelName,
        pin_code: this.pinCode,
        currency_code: this.currencyCode,
        url: window.location.href
      };
      const extraHeaders = [
        { Authorization: 'Basic ' + btoa(this.trackingId + ':' + this.pinCode) }
      ];
      return this.query(url, 'PATCH', data, extraHeaders, true, true)
        .tap((result) => {
          if (!(result.result !== undefined && result.result.id !== undefined && result.result.status === 'CREATED')) {
            this.showErrorNotification('ha ocurrido un error con el proceso de pago online, por favor, vuelva a intentarlo');
          }
        });
    })
  };

  /**
   *
   * @returns {Promise}
   */
  captureTransaction = (orderID) => {
    const url = baseUrl + '/api/hotels/' + this.hotelID + '/cms/capture_paypal_transaction/' + this.trackingId;
    const data = {
      order_id: orderID
    };
    const extraHeaders = [
      { Authorization: 'Basic ' + btoa(this.trackingId + ':' + this.pinCode) }
    ];
    return this.query(url, 'PATCH', data, extraHeaders, true, true)
      .tap((result) => {
        if (!(result.result !== undefined && result.result.id !== undefined && result.result.status === 'COMPLETED')) {
          this.showErrorNotification('ha ocurrido un error con el proceso de pago online, por favor, vuelva a intentarlo');
        }
      });
  };
}
